/**
 * HR 페이지 명시 등록 — require.context 초기 스캔 이후 추가된 화면도 메뉴 매핑 보장
 */
import HrDashboard from './HrDashboard';
import AppointmentList from './AppointmentList';
import EmployeeMasterList from './EmployeeMasterList';
import EmployeeCard from './EmployeeCard';
import OrgUnitList from './OrgUnitList';
import DeptManage from './DeptManage';
import ParameterList from './ParameterList';
import BudgetDashboard from '../budget/BudgetDashboard';
import ProcessMapSample from '../budget/ProcessMapSample';
import BudgetSubjectStructure from '../budget/BudgetSubjectStructure';
import BudgetSubjectRegister from '../budget/BudgetSubjectRegister';
import BudgetProjectStructure from '../budget/BudgetProjectStructure';
import BudgetProjectRegister from '../budget/BudgetProjectRegister';
import BudgetRoundRegister from '../budget/BudgetRoundRegister';
import BudgetFundRegister from '../budget/BudgetFundRegister';
import BudgetFundPackageRegister from '../budget/BudgetFundPackageRegister';
import BudgetExpenseRequest from '../budget/BudgetExpenseRequest';
import BudgetExpenseAdjust from '../budget/BudgetExpenseAdjust';
import BudgetIncomeRequest from '../budget/BudgetIncomeRequest';
import BudgetIncomeAdjust from '../budget/BudgetIncomeAdjust';
import BudgetRequestInquiry from '../budget/BudgetRequestInquiry';
import BudgetRequestInquiry2 from '../budget/BudgetRequestInquiry2';
import BudgetBalance from '../budget/BudgetBalance';
import BudgetAllocPlan from '../budget/BudgetAllocPlan';
import BudgetAllocProcess from '../budget/BudgetAllocProcess';
import BudgetAllocApprove from '../budget/BudgetAllocApprove';
import BudgetChangeRegister from '../budget/BudgetChangeRegister';
import BudgetChangeApprove from '../budget/BudgetChangeApprove';
import BizFormTemplateManage from '../budget/BizFormTemplateManage';
import BizPlanRhwpPoc from '../budget/BizPlanRhwpPoc';
import ExpenseProposalRegister from '../expense/ExpenseProposalRegister';
import ExpenseProposalApprove from '../expense/ExpenseProposalApprove';
import ExpenseContractRequestRegister from '../expense/ExpenseContractRequestRegister';
import ExpenseContractRequestReceive from '../expense/ExpenseContractRequestReceive';
import ExpenseObligationRegister from '../expense/ExpenseObligationRegister';
import ExpenseObligationApprove from '../expense/ExpenseObligationApprove';
import ExpenseResolutionRegister from '../expense/ExpenseResolutionRegister';
import ExpenseResolutionRegister2 from '../expense/ExpenseResolutionRegister2';
import ExpenseResolutionRegisterType1 from '../expense/ExpenseResolutionRegisterType1';
import ExpenseResolutionRegisterType2 from '../expense/ExpenseResolutionRegisterType2';
import ExpenseResolutionApprove from '../expense/ExpenseResolutionApprove';
import ExpensePaymentOrder from '../expense/ExpensePaymentOrder';
import IncomeSourceRegister from '../income/IncomeSourceRegister';
import IncomeResolutionRegister from '../income/IncomeResolutionRegister';
import IncomeResolutionApprove from '../income/IncomeResolutionApprove';
import ReceiptResolutionRegister from '../income/ReceiptResolutionRegister';
import ReceiptResolutionApprove from '../income/ReceiptResolutionApprove';
import IncomeAdjustWorkspace from '../income/IncomeAdjustWorkspace';
import IncomeOverpayment from '../income/IncomeOverpayment';
import IncomeUncollectible from '../income/IncomeUncollectible';
import TenantRegister from '../system/TenantRegister';
import UserManage from '../system/UserManage';
import DeptPermissionManage from '../system/DeptPermissionManage';
import AdminPermissionManage from '../system/AdminPermissionManage';
import ExceptionPermissionManage from '../system/ExceptionPermissionManage';
import EnvSettings from '../system/EnvSettings';
import AcctClassRegister from '../budget/AcctClassRegister';
import AcctUnitRegister from '../budget/AcctUnitRegister';
import VendorRegister from '../master/VendorRegister';
import OrgFinanceRegister from '../master/OrgFinanceRegister';
import ContractRegister from '../contract/ContractRegister';

export const HR_PAGE_REGISTRY = {
  'pages/system/TenantRegister': TenantRegister,
  'pages/system/UserManage': UserManage,
  'pages/system/DeptPermissionManage': DeptPermissionManage,
  'pages/system/AdminPermissionManage': AdminPermissionManage,
  'pages/system/ExceptionPermissionManage': ExceptionPermissionManage,
  'pages/system/EnvSettings': EnvSettings,
  // 구 메뉴·즐겨찾기 호환
  'pages/system/UserPermissionManage': AdminPermissionManage,
  'pages/system/ResponsibilityPermissionManage': AdminPermissionManage,
  'pages/system/PermissionExceptionManage': ExceptionPermissionManage,
  'pages/budget/AcctClassRegister': AcctClassRegister,
  'pages/budget/AcctUnitRegister': AcctUnitRegister,
  'pages/master/VendorRegister': VendorRegister,
  'pages/master/OrgFinanceRegister': OrgFinanceRegister,
  'pages/contract/ContractRegister': ContractRegister,
  'pages/hr/HrDashboard': HrDashboard,
  'pages/hr/AppointmentList': AppointmentList,
  'pages/hr/EmployeeMasterList': EmployeeMasterList,
  'pages/hr/EmployeeCard': EmployeeCard,
  'pages/hr/OrgUnitList': OrgUnitList,
  'pages/hr/DeptManage': DeptManage,
  'pages/hr/ParameterList': ParameterList,
  'pages/budget/BudgetDashboard': BudgetDashboard,
  'pages/budget/ProcessMapSample': ProcessMapSample,
  'pages/budget/BudgetSubjectStructure': BudgetSubjectStructure,
  'pages/budget/BudgetSubjectRegister': BudgetSubjectRegister,
  'pages/budget/BudgetProjectStructure': BudgetProjectStructure,
  'pages/budget/BudgetProjectRegister': BudgetProjectRegister,
  'pages/budget/BudgetRoundRegister': BudgetRoundRegister,
  'pages/budget/BudgetFundRegister': BudgetFundRegister,
  'pages/budget/BudgetFundPackageRegister': BudgetFundPackageRegister,
  'pages/budget/BudgetExpenseRequest': BudgetExpenseRequest,
  'pages/budget/BudgetExpenseAdjust': BudgetExpenseAdjust,
  'pages/budget/BudgetIncomeRequest': BudgetIncomeRequest,
  'pages/budget/BudgetIncomeAdjust': BudgetIncomeAdjust,
  'pages/budget/BudgetRequestInquiry': BudgetRequestInquiry,
  'pages/budget/BudgetRequestInquiry2': BudgetRequestInquiry2,
  'pages/budget/BudgetBalance': BudgetBalance,
  'pages/budget/BudgetAllocPlan': BudgetAllocPlan,
  'pages/budget/BudgetAllocProcess': BudgetAllocProcess,
  'pages/budget/BudgetAllocApprove': BudgetAllocApprove,
  'pages/budget/BudgetChangeRegister': BudgetChangeRegister,
  'pages/budget/BudgetChangeApprove': BudgetChangeApprove,
  'pages/budget/BizFormTemplateManage': BizFormTemplateManage,
  'pages/budget/BizPlanRhwpPoc': BizPlanRhwpPoc,
  'pages/expense/ExpenseProposalRegister': ExpenseProposalRegister,
  'pages/expense/ExpenseProposalApprove': ExpenseProposalApprove,
  'pages/expense/ExpenseContractRequestRegister': ExpenseContractRequestRegister,
  'pages/expense/ExpenseContractRequestReceive': ExpenseContractRequestReceive,
  'pages/expense/ExpenseObligationRegister': ExpenseObligationRegister,
  'pages/expense/ExpenseObligationApprove': ExpenseObligationApprove,
  'pages/expense/ExpenseResolutionRegister': ExpenseResolutionRegister,
  'pages/expense/ExpenseResolutionRegister2': ExpenseResolutionRegister2,
  'pages/expense/ExpenseResolutionRegisterType1': ExpenseResolutionRegisterType1,
  'pages/expense/ExpenseResolutionRegisterType2': ExpenseResolutionRegisterType2,
  'pages/expense/ExpenseResolutionApprove': ExpenseResolutionApprove,
  'pages/expense/ExpensePaymentOrder': ExpensePaymentOrder,
  'pages/income/IncomeSourceRegister': IncomeSourceRegister,
  'pages/income/IncomeResolutionRegister': IncomeResolutionRegister,
  'pages/income/IncomeResolutionApprove': IncomeResolutionApprove,
  'pages/income/ReceiptResolutionRegister': ReceiptResolutionRegister,
  'pages/income/ReceiptResolutionApprove': ReceiptResolutionApprove,
  'pages/income/IncomeAdjustWorkspace': IncomeAdjustWorkspace,
  'pages/income/IncomeOverpayment': IncomeOverpayment,
  'pages/income/IncomeUncollectible': IncomeUncollectible,
};
